// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  formValues: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Full Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Email</b> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="email"
            value={data.email || ''}
            name="email"
            id="email"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Username</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.login || ''}
            name="login"
            id="login"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Password</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="password"
            value={data.password || ''}
            name="password"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <label className="label">
              &nbsp;
          </label>
          <input
            className="inputNew"
            type="checkbox"
            name="active"
            id="active"
            data-handler-type="boolean"
            checked={data.active || false}
            onChange={props.onChange}
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Active
          </label>
        </div>
      </div>
    </fieldset>
  );
}

export default Form;
